// deployment_class: internal_only
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { AuthProvider } from './shell/auth/AuthProvider';
import { ErrorBoundary } from './shell/error/ErrorBoundary';
import { installPreloadRecovery } from './shell/boot/preload-recovery';
import './shell/styles/tokens.css';

// UI-B5 · a tab holding a previous build asks for chunk hashes that no longer
// exist after a deploy. Installed BEFORE render so a lazy route failing during
// the very first navigation is still caught. Reloads once, and refuses to
// reload again inside a cooldown so a broken build cannot spin the tab.
installPreloadRecovery();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Root element #root not found in DOM');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
